module.exports = __webpack_public_path__ + "static/media/logoWarriors.e9c81f41.jpg";